module.exports = __webpack_public_path__ + "img/full0-min.e1e6b397.png";